import { render, staticRenderFns } from "./MovieMy.vue?vue&type=template&id=95d422ee&scoped=true&"
import script from "./MovieMy.vue?vue&type=script&lang=js&"
export * from "./MovieMy.vue?vue&type=script&lang=js&"
import style0 from "./MovieMy.vue?vue&type=style&index=0&id=95d422ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d422ee",
  null
  
)

export default component.exports